import { useEffect, useState } from 'react';
import { SpeechTheme } from './components/SpeechTheme';
import { KlartextEventConfig } from '@common/types/klartextEventConfig';
import { KioskModeProvider } from './providers/kioskMode';
import { KlartextEventConfigContext } from './providers/klartextEventConfig';
import { SpeechAnalysis } from './components/SpeechAnalysis';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import useCollectionSnapshot from './hooks/useCollectionSnapshot';
import { CornerStyling } from './components/CornerStyling';
import { FrontendSpecificConfig } from '@configTypes/eventConfigs';

function App() {
  const [selectedEventId, setSelectedEventId] = useState<string | null>(null);
  const [selectedKlartextEventConfig, setSelectedklartextEventConfig] =
    useState<KlartextEventConfig<FrontendSpecificConfig> | null>(null);

  const { data: klartextEventConfigs } = useCollectionSnapshot<KlartextEventConfig<FrontendSpecificConfig>[]>({
    collectionPath: `events`,
    initialState: [] as KlartextEventConfig<FrontendSpecificConfig>[],
  });

  useEffect(() => {
    if (selectedEventId) {
      const klartextEventConfig = klartextEventConfigs.find(
        (klartextEventConfig: KlartextEventConfig<FrontendSpecificConfig>) =>
          klartextEventConfig.eventId === selectedEventId,
      );
      setSelectedklartextEventConfig(klartextEventConfig ? { ...klartextEventConfig } : null);
    } else {
      setSelectedklartextEventConfig(null);
    }
  }, [selectedEventId, klartextEventConfigs]);

  return (
    <KlartextEventConfigContext.Provider value={selectedKlartextEventConfig}>
      <SpeechTheme klartextEventConfig={selectedKlartextEventConfig}>
        <CornerStyling>
          <Router>
            <KioskModeProvider>
              <Routes>
                <Route path="/" element={<LandingPage klartextEventConfigs={klartextEventConfigs} />} />
                {klartextEventConfigs.map(eventConfig => (
                  <Route
                    key={eventConfig.eventId}
                    path={`/${eventConfig.eventId}`}
                    element={<SpeechAnalysis onLoad={(eventId: string | null) => setSelectedEventId(eventId)} />}
                  />
                ))}
              </Routes>
            </KioskModeProvider>
          </Router>
        </CornerStyling>
      </SpeechTheme>
    </KlartextEventConfigContext.Provider>
  );
}

export default App;
